import React, { useEffect, useState } from "react";
import CloudStorage from "../../../../../../../CloudStorage/CloudStorage";
import { formatNumberWithCommas, getJobPriceWithLabel } from "../../../../../../Common/AllDateTimeReleventFormate";
import { Modal } from "reactstrap";
import ModelContractPost from "../../../../../../Common/ContractandPost/ModelContractPost";
import ModelGiveReview from "../../../../../../Common/ContractandPost/ModelGiveReview";
import ModelPostDetails from "../../../../../../Common/ContractandPost/ModelPostDetails";
import { useRouteBaseStateContext } from "../../../../../../../Context/RouteBaseStateContext";
import ProfilePic from "../../../../../../../assests/imgs/Profileplaceholder.svg";
import { useDispatch, useSelector } from "react-redux";
import { postsCancelByIdAPI } from "../../../../../../../redux/posts/action";
import ModelAcceptRejectPost from "../../../../../../Common/ContractandPost/ModelAcceptRejectPost";
import { AcceptAllProposal } from "../../../../../../../redux/job/action";
import { useNavigate } from "react-router-dom";
import { cancelledredlabel, completedgreenlabel } from "../../../../../../Common/CommonLabels";
import ProfileImageWithFallback from "../../../../../../../common/ProfileImageWithFallback";
import ConfirmModal from "../../../../../../Common/ConfirmModal";
import { decodeHtml } from "../../../../../../../assests/extention/commonfunction";

export default function MineActiveJobOverview({ posts, proposalmilestones }) {
  const { setMyorderActivejobsroute } = useRouteBaseStateContext();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const [viewPost, setviewPost] = useState(false);
  const [contract, setContact] = useState(false);
  const [review, setReview] = useState(false);
  const [acceptreject, setAcceptreject] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const profile = useSelector(({ profile: { profiledata } }) => profiledata);


  const dispatch = useDispatch()
  const postsCancelBy = (value) => {
    const data = {
      "post_id": posts?.id, "type": "3", "status": value == 2 ? 22 : "24"
    }
    dispatch(postsCancelByIdAPI(data))
    setAcceptreject(false)
  }
  useEffect(() => {
    if (posts?.cancle_requested == 1 && posts?.is_mine == 1 && posts?.status != 23 && posts?.status != 24) {
      setAcceptreject(true)
    }
  }, [posts?.cancle_requested])

  const cancleit = (value) => {
    if (value == 1) {
      postsCancelBy(1)
    }
    else {
      postsCancelBy(2)
    }
  }

  const paytheAmount = () => {
    const state = {
      id: proposalmilestones?.id,
      type: 3,
      type_of_post: "jobwithrepay",
      post_id: posts?.id,
      post_price: proposalmilestones?.first_amount,
    };

    const data = {
      // ...values,
      type: "3",
      id: proposalmilestones?.id,
      image: 'screenshotUrl',
      url: `/${lan}/account/paymentmethodpage`,
      state: state,
      status: "23",
    };
    console.log(data, 'datadatadata');

    // Only dispatch API call if screenshotUrl is valid
    // dispatch(AcceptAllProposal(data, setLoading, navigate));
    navigate(data?.url, { state: { orderdetails: data?.state } });
  }

  return (
    <div className=" project-section project-details p-0">
      <div className="post-details col-md-12">
        <div className="row active-row">
          <div className="col-md-12 signup-back">
            <div className="post-back signup-sec">
              <div className="col-md-5 overview-left">
                <p>
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/myorders/jobtype.svg`}
                    alt=""
                  />
                  Job type:
                  {posts?.work_location == 1
                    ? "Virtual"
                    : posts?.work_location == 2
                      ? "Physical"
                      : ""}
                </p>
                <h3>{decodeHtml(posts?.title)}</h3>
                <h1>
                  {getJobPriceWithLabel(proposalmilestones?.price, posts?.hiring_type)}
                </h1>
                <br></br>
                {(posts?.is_mine == 1 && proposalmilestones?.re_pay == 1) &&
                  <button
                    onClick={() => paytheAmount()}
                    className="btn submit-work"
                  >
                    Pay next {posts?.hiring_type == 4 ? 'month' : 'week'}  amount
                  </button>
                }
              </div>
              {posts?.is_mine == 1 ? (
                <>
                  {proposalmilestones?.first_name &&
                    <div className=" col-md-4 overview-center">
                      <span>About Expert </span>
                      <div className="expert-left pt-2 d-flex align-items-center">
                        <ProfileImageWithFallback url={proposalmilestones?.profile_image} style={{ height: "80px", width: "80px" }} />
                        <div>
                          <h2>
                            {decodeHtml(proposalmilestones?.first_name)} &nbsp;
                            {decodeHtml(proposalmilestones?.last_name)}
                          </h2>
                          <h6 className="pt-2">{decodeHtml(proposalmilestones?.designation)} </h6>
                          <h2>
                            <p>
                              <img
                                width={40}
                                src={`${CloudStorage.cloudurl}/Assets/Images/project/location.svg`}
                                alt=""
                              />
                              Location: {proposalmilestones?.working_country_title}
                            </p>
                          </h2>
                          <p>
                            <i className="fa-solid fa-star"></i>
                            {proposalmilestones?.expert_rating || 0} (
                            {proposalmilestones?.expert_comment_count || 0} reviews)
                          </p>
                          {/* <p>Location: {proposalmilestones.location}</p> */}
                        </div>
                      </div>
                    </div>
                  }
                </>
              ) : (
                <div className=" col-md-4 overview-center">
                  <span>About the Client  </span>
                  <div className="expert-left d-flex align-items-center">
                    <ProfileImageWithFallback url={posts?.user?.profile_image} style={{ height: "80px", width: "80px" }} />
                    <div>
                      <h2>
                        {decodeHtml(posts?.user?.first_name)} {decodeHtml(posts?.user?.last_name)}
                      </h2>
                      <h6>{decodeHtml(posts?.user?.designation)} </h6>
                      <p>
                        <i className="fa-solid fa-star"></i>&nbsp;&nbsp;
                        {posts?.user?.rating} ({posts?.user?.reviews} reviews)
                      </p>
                      <p>
                        <img
                          width={40}
                          src={`${CloudStorage.cloudurl}/Assets/Images/project/location.svg`}
                          alt=""
                        />
                        Location: {posts?.user?.country}
                      </p>
                    </div>
                  </div>
                </div>
              )}

              {posts?.is_mine == 1 ? (
                <>
                  {posts?.status == 23 ? (
                    <div className="col overview-right">
                      <button
                        style={{ background: "green" }}
                        className="btn submit-work"
                      >
                        Job Completed
                      </button>
                    </div>
                  ) : (
                    <div className="col overview-right">
                      <button
                        onClick={() => setMyorderActivejobsroute("Messages")}
                        className="btn submit-work"
                      >
                        <img
                          src={`${CloudStorage.cloudurl}/Assets/Images/myorders/message-white.svg`}
                          alt=""
                        />
                        Message
                      </button>
                    </div>
                  )}
                </>
              ) : (
                <>
                  {posts?.status == 23 ? (
                    <div className="col overview-right">
                      <button
                        style={{ background: "green" }}
                        className="btn submit-work"
                      >
                        Job Completed
                      </button>
                    </div>
                  ) : (
                    <div className="col overview-right">
                      <button
                        onClick={() => setMyorderActivejobsroute("Timesheet")}
                        className="btn submit-work"
                      >
                        + Log time
                      </button>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
          <div className="col-md-4 signup-back">
            <div className="signup-sec">
              <h4>Logged Hour</h4>
              <h1>{proposalmilestones?.logged_hours || 0} hrs</h1>
            </div>
          </div>
          <div className="col-md-4 signup-back">
            <div className="signup-sec">
              <h4>Approved hour</h4>
              <h1>{proposalmilestones?.approved_hours || 0} hrs</h1>
            </div>
          </div>
          <div className="col-md-4 signup-back">
            <div className="signup-sec">
              {posts?.is_mine == 1 ? (
                <h4>Total Payment Paid</h4>
              ) : (
                <h4>Total Payment Received</h4>
              )}
              <h1>SAR {proposalmilestones?.payment_recieved || 0} </h1>
            </div>
          </div>
          <div className="col-md-12 post-contract">
            <a onClick={() => setviewPost((state) => !state)}>
              View post
              <img
                src={`${CloudStorage.cloudurl}Assets/Images/dashboard/square-arrow.svg`}
                alt=""
              />
            </a>
            <a onClick={() => setContact((state) => !state)}>
              View contract
              <img
                src={`${CloudStorage.cloudurl}Assets/Images/dashboard/square-arrow.svg`}
                alt=""
              />
            </a>
            <a onClick={() => posts?.status == 22 && setConfirmModal(true)}>
              {(posts?.status != 24 && posts?.cancle_requested == 1) ? 'Cancel Requested' : posts?.status == 24 ? cancelledredlabel : posts?.status == 23 ? completedgreenlabel : 'Cancel'}
              {(posts?.status == 22 && posts?.cancle_requested != 1) && (
                <img src={`${CloudStorage.cloudurl}Assets/Images/dashboard/square-arrow.svg`} alt="" />
              )}
            </a>

            {posts?.status == 23 &&
              <>
                {
                  proposalmilestones?.post_rating > 0 ?
                    <a >
                      Already Reviewed
                    </a>
                    :
                    <a onClick={() => setReview((state) => !state)}>
                      Give Review
                      <img
                        src={`${CloudStorage.cloudurl}Assets/Images/dashboard/square-arrow.svg`}
                        alt=""
                      />
                    </a>
                }
              </>
            }

          </div>
        </div>
      </div>

      <Modal
        size="xl"
        className="popupmodal rent-modal"
        isOpen={acceptreject}
      // toggle={() => setAcceptreject((state) => !state)}
      >
        <ModelAcceptRejectPost setAcceptreject={setAcceptreject} posts={posts} cancleit={cancleit} />
      </Modal>


      <Modal
        size="xl"
        className="popupmodal rent-modal"
        isOpen={viewPost}
        toggle={() => setviewPost((state) => !state)}
      >
        <ModelPostDetails setviewPost={setviewPost} posts={posts} proposalmilestones={proposalmilestones} />
      </Modal>
      <Modal
        size="xl"
        className="popupmodal rent-modal"
        isOpen={contract}
        toggle={() => setContact((state) => !state)}
      >
        <ModelContractPost
          setContact={setContact}
          proposalmilestones={proposalmilestones}
        />
      </Modal>
      <Modal
        size="xl"
        className="popupmodal rent-modal"
        isOpen={review}
        toggle={() => setReview((state) => !state)}
      >
        <ModelGiveReview
          setReview={setReview}
          proposalmilestones={proposalmilestones}
          posts={posts}
        />
      </Modal>
      <ConfirmModal
        isOpen={confirmModal}
        toggle={() => setConfirmModal(false)}
        title="Confirm Cancellation"
        message={`Are you sure you want to cancel this post?`}
        confirmpopupmessage={`All pending logged time will be rejected, and payment will be released only for accepted logged time.This action cannot be undone.
          As per admin configuration, each user is allowed a limited number of cancellations. You have used ${profile?.settings?.total_cancelation || 0} out of ${profile?.settings?.max_cancelation || 0} allowed cancellations.`}
        onConfirm={() => postsCancelBy()}
        showConfirmModel={true}
      />
    </div>
  );
}

// PREEMPTIVE HMR BURST
